// Re-export from reporting-data
import { AreaVisualOptions } from 'reporting-data/relational/reports/visuals/area-visual-records';
import { ComboVisualOptions } from 'reporting-data/relational/reports/visuals/combo-visual-records';
import { DonutVisualOptions } from 'reporting-data/relational/reports/visuals/donut-visual-records';
import { HorizontalBarVisualOptions } from 'reporting-data/relational/reports/visuals/horizontal-bar-visual-records';
import { LineVisualOptions } from 'reporting-data/relational/reports/visuals/line-visual-records';
import { PieVisualOptions } from 'reporting-data/relational/reports/visuals/pie-visual-records';
import { PivotTableVisualOptions } from 'reporting-data/relational/reports/visuals/pivot-table-visual-records';
import { ScatterVisualOptions } from 'reporting-data/relational/reports/visuals/scatter-visual-records';
import { TableVisualOptions } from 'reporting-data/relational/reports/visuals/table-visual-records';
import { TextVisualOptions } from 'reporting-data/relational/reports/visuals/text-visual-records';
import { VerticalBarVisualOptions } from 'reporting-data/relational/reports/visuals/vertical-bar-visual-records';
import { GaugeVisualOptions } from 'reporting-data/relational/reports/visuals/gauge-visual-records';
import { getChannelHelpText } from '../utils/channel-utils';
import { VisualTypes } from 'reporting-data/relational/reports/visual-records';
import { COLUMN_ROLES } from 'reporting-data/constants/relationalReports';
import { Channel, ChannelNames, ChannelTypes } from 'reporting-data/relational/reports/visual-records';
import { buildTypedMap } from 'reporting-data/relational/utility-types';
export * from 'reporting-data/relational/reports/visual-records';
const setDisplayOrder = (order, channel) => channel.set('displayOrder', order);

// TODO: remove "-channel" suffix when we fix x and y channels
export const colorChannel = Channel({
  name: ChannelNames.COLOR,
  label: 'reporting-snowflake.channels.color-channel',
  type: ChannelTypes.SINGLE
});
export const sizingChannel = Channel({
  name: ChannelNames.SIZING,
  label: 'reporting-snowflake.channels.sizing-channel',
  type: ChannelTypes.SINGLE,
  helpText: getChannelHelpText(ChannelNames.SIZING)
});
export const detailChannel = Channel({
  name: ChannelNames.DETAIL,
  label: 'reporting-snowflake.channels.detail-channel',
  type: ChannelTypes.SINGLE,
  helpText: getChannelHelpText(ChannelNames.DETAIL)
});
export const valuesChannel = Channel({
  name: ChannelNames.VALUES,
  label: 'reporting-snowflake.channels.values-channel',
  type: ChannelTypes.MULTIPLE
});
export const singleValueChannel = Channel({
  name: ChannelNames.SINGLE_VALUE,
  label: 'reporting-snowflake.channels.single-value-channel',
  type: ChannelTypes.SINGLE
});
export const groupChannel = Channel({
  name: ChannelNames.GROUP,
  label: 'reporting-snowflake.channels.group-channel',
  type: ChannelTypes.SINGLE
});
export const rowsChannel = Channel({
  name: ChannelNames.ROWS,
  label: 'reporting-snowflake.channels.rows-channel',
  type: ChannelTypes.MULTIPLE
});
export const columnsChannel = Channel({
  name: ChannelNames.COLUMNS,
  label: 'reporting-snowflake.channels.columns-channel',
  type: ChannelTypes.MULTIPLE
});
export const xChannel = Channel({
  name: ChannelNames.X,
  label: 'reporting-snowflake.channels.x-channel',
  type: ChannelTypes.SINGLE
});
export const xMultiChannel = Channel({
  name: ChannelNames.X_MULTI,
  label: 'reporting-snowflake.channels.x-multi-channel',
  type: ChannelTypes.MULTIPLE
});
export const compareChannel = Channel({
  name: ChannelNames.COMPARE,
  label: 'reporting-snowflake.channels.x-channel',
  type: ChannelTypes.SINGLE
});
export const yChannel = Channel({
  name: ChannelNames.Y,
  label: 'reporting-snowflake.channels.y-channel',
  type: ChannelTypes.SINGLE
});
export const yMultiChannel = Channel({
  name: ChannelNames.Y_MULTI,
  label: 'reporting-snowflake.channels.y-multi-channel',
  type: ChannelTypes.MULTIPLE
});
export const y1Channel = Channel({
  name: ChannelNames.Y_1,
  label: 'reporting-snowflake.channels.y1-channel',
  type: ChannelTypes.SINGLE
});
export const y2Channel = Channel({
  name: ChannelNames.Y_2,
  label: 'reporting-snowflake.channels.y2-channel',
  type: ChannelTypes.SINGLE
});
export const breakdownFirstMeasureChannel = Channel({
  name: ChannelNames.BREAKDOWN,
  label: 'reporting-snowflake.channels.breakdown-first-measure-channel',
  type: ChannelTypes.SINGLE
});
export const verticalBarChannels = buildTypedMap({
  [ChannelNames.X]: setDisplayOrder(0, xChannel),
  [ChannelNames.Y_MULTI]: setDisplayOrder(1, yMultiChannel),
  [ChannelNames.Y]: setDisplayOrder(2, yChannel),
  [ChannelNames.COLOR]: setDisplayOrder(3, colorChannel)
});
export const horizontalBarChannels = buildTypedMap({
  [ChannelNames.X_MULTI]: setDisplayOrder(0, xMultiChannel),
  [ChannelNames.X]: setDisplayOrder(1, xChannel),
  [ChannelNames.Y]: setDisplayOrder(2, yChannel),
  [ChannelNames.COLOR]: setDisplayOrder(3, colorChannel)
});
export const lineChannels = buildTypedMap({
  [ChannelNames.X]: setDisplayOrder(0, xChannel),
  [ChannelNames.Y_MULTI]: setDisplayOrder(1, yMultiChannel),
  [ChannelNames.Y]: setDisplayOrder(2, yChannel),
  [ChannelNames.COLOR]: setDisplayOrder(3, colorChannel)
});
export const areaChannels = buildTypedMap({
  [ChannelNames.X]: setDisplayOrder(0, xChannel),
  [ChannelNames.Y_MULTI]: setDisplayOrder(1, yMultiChannel),
  [ChannelNames.Y]: setDisplayOrder(2, yChannel),
  [ChannelNames.COLOR]: setDisplayOrder(3, colorChannel)
});
export const scatterChannels = buildTypedMap({
  [ChannelNames.X]: setDisplayOrder(0, xChannel),
  [ChannelNames.Y]: setDisplayOrder(1, yChannel),
  [ChannelNames.COLOR]: setDisplayOrder(2, colorChannel),
  [ChannelNames.DETAIL]: setDisplayOrder(3, detailChannel),
  [ChannelNames.SIZING]: setDisplayOrder(4, sizingChannel)
});
export const pieChannels = buildTypedMap({
  [ChannelNames.COLOR]: setDisplayOrder(0, colorChannel),
  [ChannelNames.VALUES]: setDisplayOrder(1, valuesChannel)
});
export const donutChannels = buildTypedMap({
  [ChannelNames.COLOR]: setDisplayOrder(0, colorChannel),
  [ChannelNames.VALUES]: setDisplayOrder(1, valuesChannel)
});
export const textChannels = buildTypedMap({
  [ChannelNames.GROUP]: setDisplayOrder(0, groupChannel),
  [ChannelNames.COMPARE]: setDisplayOrder(1, compareChannel),
  [ChannelNames.VALUES]: setDisplayOrder(2, valuesChannel)
});
export const tableChannels = buildTypedMap({
  [ChannelNames.COLUMNS]: setDisplayOrder(0, columnsChannel)
});
export const magicWandChannels = buildTypedMap({
  [ChannelNames.COLUMNS]: setDisplayOrder(0, columnsChannel)
});
export const pivotTableChannels = buildTypedMap({
  [ChannelNames.ROWS]: setDisplayOrder(0, rowsChannel),
  [ChannelNames.COLUMNS]: setDisplayOrder(1, columnsChannel),
  [ChannelNames.VALUES]: setDisplayOrder(2, valuesChannel)
});
export const comboChannels = buildTypedMap({
  [ChannelNames.X]: setDisplayOrder(0, xChannel),
  [ChannelNames.Y_1]: setDisplayOrder(1, y1Channel),
  [ChannelNames.Y_2]: setDisplayOrder(2, y2Channel),
  [ChannelNames.BREAKDOWN]: setDisplayOrder(3, breakdownFirstMeasureChannel)
});
export const gaugeChannels = buildTypedMap({
  [ChannelNames.SINGLE_VALUE]: setDisplayOrder(0, singleValueChannel),
  [ChannelNames.COMPARE]: setDisplayOrder(1, compareChannel)
});
export const channelMetadata = buildTypedMap({
  [ChannelNames.COLOR]: colorChannel,
  [ChannelNames.SIZING]: sizingChannel,
  [ChannelNames.DETAIL]: detailChannel,
  [ChannelNames.VALUES]: valuesChannel,
  [ChannelNames.SINGLE_VALUE]: singleValueChannel,
  [ChannelNames.GROUP]: groupChannel,
  [ChannelNames.ROWS]: rowsChannel,
  [ChannelNames.COLUMNS]: columnsChannel,
  [ChannelNames.X]: xChannel,
  [ChannelNames.X_MULTI]: xMultiChannel,
  [ChannelNames.Y]: yChannel,
  [ChannelNames.Y_MULTI]: yMultiChannel,
  [ChannelNames.Y_1]: yChannel,
  [ChannelNames.Y_2]: yChannel,
  [ChannelNames.BREAKDOWN]: breakdownFirstMeasureChannel,
  [ChannelNames.COMPARE]: compareChannel
});
export const relationalReportChannels = buildTypedMap({
  [VisualTypes.VERTICAL_BAR]: verticalBarChannels,
  [VisualTypes.HORIZONTAL_BAR]: horizontalBarChannels,
  [VisualTypes.LINE]: lineChannels,
  [VisualTypes.AREA]: areaChannels,
  [VisualTypes.SCATTER]: scatterChannels,
  [VisualTypes.PIE]: pieChannels,
  [VisualTypes.DONUT]: donutChannels,
  [VisualTypes.TEXT]: textChannels,
  [VisualTypes.TABLE]: tableChannels,
  [VisualTypes.PIVOT_TABLE]: pivotTableChannels,
  [VisualTypes.COMBO]: comboChannels,
  [VisualTypes.MAGIC_WAND]: magicWandChannels,
  [VisualTypes.GAUGE]: gaugeChannels
});
export const visualOptionsByType = buildTypedMap({
  [VisualTypes.VERTICAL_BAR]: VerticalBarVisualOptions,
  [VisualTypes.HORIZONTAL_BAR]: HorizontalBarVisualOptions,
  [VisualTypes.LINE]: LineVisualOptions,
  [VisualTypes.AREA]: AreaVisualOptions,
  [VisualTypes.SCATTER]: ScatterVisualOptions,
  [VisualTypes.PIE]: PieVisualOptions,
  [VisualTypes.DONUT]: DonutVisualOptions,
  [VisualTypes.TEXT]: TextVisualOptions,
  [VisualTypes.TABLE]: TableVisualOptions,
  [VisualTypes.PIVOT_TABLE]: PivotTableVisualOptions,
  [VisualTypes.COMBO]: ComboVisualOptions,
  [VisualTypes.GAUGE]: GaugeVisualOptions
});
export const preferredChannelRoleByVisualType = buildTypedMap({
  [VisualTypes.VERTICAL_BAR]: buildTypedMap({
    [ChannelNames.X]: COLUMN_ROLES.DIMENSION,
    [ChannelNames.Y]: COLUMN_ROLES.MEASURE,
    [ChannelNames.Y_MULTI]: COLUMN_ROLES.MEASURE,
    [ChannelNames.COLOR]: COLUMN_ROLES.DIMENSION
  }),
  [VisualTypes.HORIZONTAL_BAR]: buildTypedMap({
    [ChannelNames.X]: COLUMN_ROLES.MEASURE,
    [ChannelNames.X_MULTI]: COLUMN_ROLES.MEASURE,
    [ChannelNames.Y]: COLUMN_ROLES.DIMENSION,
    [ChannelNames.COLOR]: COLUMN_ROLES.DIMENSION
  }),
  [VisualTypes.LINE]: buildTypedMap({
    [ChannelNames.X]: COLUMN_ROLES.DIMENSION,
    [ChannelNames.Y]: COLUMN_ROLES.MEASURE,
    [ChannelNames.Y_MULTI]: COLUMN_ROLES.MEASURE,
    [ChannelNames.COLOR]: COLUMN_ROLES.DIMENSION
  }),
  [VisualTypes.AREA]: buildTypedMap({
    [ChannelNames.X]: COLUMN_ROLES.DIMENSION,
    [ChannelNames.Y]: COLUMN_ROLES.MEASURE,
    [ChannelNames.Y_MULTI]: COLUMN_ROLES.MEASURE,
    [ChannelNames.COLOR]: COLUMN_ROLES.DIMENSION
  }),
  [VisualTypes.SCATTER]: buildTypedMap({
    [ChannelNames.X]: COLUMN_ROLES.MEASURE,
    [ChannelNames.Y]: COLUMN_ROLES.MEASURE,
    [ChannelNames.COLOR]: COLUMN_ROLES.DIMENSION,
    [ChannelNames.DETAIL]: COLUMN_ROLES.DIMENSION,
    [ChannelNames.SIZING]: COLUMN_ROLES.MEASURE
  }),
  [VisualTypes.PIE]: buildTypedMap({
    [ChannelNames.COLOR]: COLUMN_ROLES.DIMENSION,
    [ChannelNames.VALUES]: COLUMN_ROLES.MEASURE
  }),
  [VisualTypes.DONUT]: buildTypedMap({
    [ChannelNames.COLOR]: COLUMN_ROLES.DIMENSION,
    [ChannelNames.VALUES]: COLUMN_ROLES.MEASURE
  }),
  [VisualTypes.TEXT]: buildTypedMap({
    [ChannelNames.GROUP]: COLUMN_ROLES.DIMENSION,
    [ChannelNames.VALUES]: COLUMN_ROLES.MEASURE
  }),
  [VisualTypes.TABLE]: buildTypedMap({
    [ChannelNames.COLUMNS]: null
  }),
  [VisualTypes.PIVOT_TABLE]: buildTypedMap({
    [ChannelNames.COLUMNS]: COLUMN_ROLES.DIMENSION,
    [ChannelNames.VALUES]: COLUMN_ROLES.MEASURE,
    [ChannelNames.ROWS]: COLUMN_ROLES.DIMENSION
  }),
  [VisualTypes.COMBO]: buildTypedMap({
    [ChannelNames.X]: COLUMN_ROLES.DIMENSION,
    [ChannelNames.Y_1]: COLUMN_ROLES.MEASURE,
    [ChannelNames.Y_2]: COLUMN_ROLES.MEASURE
  }),
  [VisualTypes.GAUGE]: buildTypedMap({
    [ChannelNames.SINGLE_VALUE]: COLUMN_ROLES.MEASURE
  })
});